// extracted by mini-css-extract-plugin
module.exports = {"arrow":"NonDeterministicPagination_arrow__NyYz_","icon":"NonDeterministicPagination_icon__5UwjX"};